// @flow

type Filter = { id: string, categoryKey: string };

export const categorizedFilterPredicate = (
  filters: $ReadOnlyArray<Filter>,
  getEntityIdsByCategory: (entity: Object, categoryKey: string) => $ReadOnlyArray<string>,
): ((entity: Object) => boolean) => {
  if (!filters || filters.length === 0) return (_entity: Object) => true;
  const byCategory: { [string]: string[] } = {};
  filters.forEach((f) => {
    if (!f || !f.id || !f.categoryKey) return;
    (byCategory[f.categoryKey] = byCategory[f.categoryKey] || []).push(f.id);
  });
  const categoryKeys = Object.keys(byCategory);
  return (entity: Object): boolean =>
    categoryKeys.every((categoryKey) => {
      const wanted = byCategory[categoryKey];
      const entityIds = getEntityIdsByCategory(entity, categoryKey) || [];
      return entityIds.some((id) => wanted.includes(id));
    });
};
